<div id="layoutHome" class="web-center">
    <div class="web-left row" [style]="!isMobile ? 'width: 70%;' : 'width: 80%;'">
        <div class="mt-5 web-left" [class]="!isMobile ? 'col-md-8' : 'col-md-12'">
            <div class="container-img">
                <img [src]="blogModel.titleImage" class="w-100"/>
            </div>
            <div class="mt-4 web-left mx-2 d-flex">
                <button [style.background-color]="'#dfdfef'" class="btn btn-primary py-1 mt-2 mx-2 tagbutton d-flex"
                    *ngIf="blogModel.hashtags != 'null'">
                    <img src="assets/images/skipping-rope.png" style="width: 20px;height: 20px;"
                        class="mx-2" alt="">
                    <span style="font-size: 1.143rem;color: #2C2C30;">{{blogModel.hashtags}}</span>
                </button>
                <!--button [style.background-color]="'#dfdfef'" class="btn btn-primary py-1 mt-2 tagbutton d-flex">
                    <img src="assets/images/pin.png" style="width: 20px;height: 20px;" class="mx-1"
                        alt="">
                    <span style="font-size: 1.143rem;color: #2C2C30;">Yoga, gym</span>
                </button-->
            </div>
            <div class="mt-4 fm-rubik fs-blog--title">
                {{ blogModel.title }}
            </div>
            <div class="mt-4 fm-rubik fs-paragraph--small" style="width: 90%;">
                <div [innerHTML]="blogModel.content"></div>
            </div>
            <div class="mt-1 mb-5 fm-rubik" style="font-size: 1rem;color: #2C2C30;">
                {{ formatDate(blogModel.date) }}
            </div>
        </div>
        <div class="col-md-4 mt-5" *ngIf="allBlogsModel.length>0 && !isMobile">
            <div class="mx-5 mb-3 font-other">Articles you might like:</div>
            <ng-container *ngFor="let item of allBlogsModel">
                <ng-container *ngTemplateOutlet="listCards; context: { $implicit: item }"></ng-container>
            </ng-container>
        </div>     
    </div>

    <div class="col-md-4 mx-3 mb-3 font-other" *ngIf="isMobile">Articles you might like:</div>
    <div class="menu-container no-scrollbar" *ngIf="allBlogsModel.length>0 && isMobile">
        <ul class="menu-list" style="display: flex; overflow-x: auto; white-space: nowrap; align-items: stretch;">
            <li *ngFor="let item of allBlogsModel" class="mb-2 mt-2 p-2"
                style="cursor: pointer; list-style-type: none; flex: 0 0 auto; display: flex;">
                <ng-container *ngTemplateOutlet="listCards; context: { $implicit: item }"></ng-container>
            </li>
        </ul>
    </div>
</div>


<ng-template #listCards let-item>
    <div class="mb-3 mx-3 position-relative responsiveCardFont fm-rubik" style="width: 85%;"
        [class]="isMobile ? 'max-width-mobile' : ''" (mouseenter)="mouseEnter(item)" (mouseleave)="mouseLeave(item)">
        <div class="card w-100 p-0 z-2 card-article h-100 d-flex flex-column" [ngClass]="item.is_hover ? 'shadow-blue': 'shadow'"
            [class]="isMobile ? 'max-height-mobile' : ''" style="cursor: pointer;" (click)="navigateToBlogDetail(item)">
            <div class="w-100 z-1">
                <img class="w-100" [src]="item.titleImage" style="border-radius: 24px 24px 0 0;"
                    [class]="isMobile ? 'mobile-img-height' : ''" />
            </div>
            <div class="card-body" [class]="isMobile ? 'mobile-flex' : ''">
                <div class="font-title" style="word-wrap: break-word; white-space: normal;"> {{item.title}}</div>
                <div *ngIf="!isMobile" class="web-left mt-2 font-description"><span>{{ item.content_substring }}</span></div>
                <div class="d-flex mt-4">
                    <button [style.background-color]="'#dfdfef'"
                        class="btn btn-primary py-1 mt-2 mx-2 categoriesButton1" *ngIf="item.hashtags">
                        {{item.hashtags}}
                    </button>
                    <button [style.background-color]="'#dfdfef'"
                        class="btn btn-primary py-1 mt-2 mx-2 categoriesButton1" *ngIf="!item.hashtags"
                        style="visibility: hidden;">
                        Null
                    </button>
                    <span class="fw-bold mt-2" style="position: absolute;right: 5%;cursor: pointer;font-size: 1rem;"
                        (click)="navigateToBlogDetail(item)">Read more</span>
                </div>
            </div>
        </div>
    </div>
</ng-template>